// extracted by mini-css-extract-plugin
export default {"clock":"Clock_clock__xtjWm","dateWrapper":"Clock_dateWrapper__tXRHp","dateFull":"Clock_dateFull__S+dz1","dateShort":"Clock_dateShort__S95wU","dateInput":"Clock_dateInput__9fJ3E"};